import { render, staticRenderFns } from "./TabsHubComponent.vue?vue&type=template&id=51fdc992&"
import script from "./TabsHubComponent.vue?vue&type=script&lang=ts&"
export * from "./TabsHubComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports